import get from 'lodash/get';
import { createSelector } from 'reselect';

/**
 * @typedef {Object} ExtraQuestion
 * @property {number} id
 * @property {string} text
 * @property {"boolean"|"select"|"text"} kind
 * @property {{ id: number, text: string }[]|undefined} options
 * @property {ExtraQuestion[]|undefined} childQuestions
 * */

/**
 * @param {Object} state
 * @param {[ExtraQuestion]} state.list
 * */
export const selectRootState = state =>
  get(state, 'paperwork.paperworkAdditionalInfo');

export const selectExtraQuestions = createSelector(
  selectRootState,
  state => get(state, 'list', []),
);

export const selectShowPaperworkAppointmentQuestionStep = createSelector(
  selectRootState,
  state => !!get(state, 'list.length'),
);



// WEBPACK FOOTER //
// ./src/redux/paperwork/selectors/paperwork-additional-info.js